import React from 'react';
import { useNamespacedTranslation } from '../../../../hooks/useNamespacedTranslation';
import { useFlairBreadcrumbHook } from '../../../../hooks/useFlairBreadcrumbHook';
import PageHeader from '../../components/PageHeader';
import { CorporateDocuments } from './CorporateDocuments';
import { TableSortProvider } from '../../../../context/TableSortingContext';

const i18CompanyNav = 'navigation.menuItems.company';

export const CompanyDocumentsPage: React.FC = () => {
  const t = useNamespacedTranslation(i18CompanyNav);

  useFlairBreadcrumbHook([
    { label: t('title') },
    { label: t('subMenuItems.documents.title') },
  ]);

  return (
    <div className="position-relative">
      <PageHeader title={t('subMenuItems.documents.title')} />
      <TableSortProvider storeAgeKey="company-documents">
        <CorporateDocuments />
      </TableSortProvider>
    </div>
  );
};
